import { Component, OnInit, Inject, ViewChild, TemplateRef, Output, EventEmitter, Input, Injector } from '@angular/core';
import LanguagesFormComponentView from './languages-form.component.html';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslateService} from '@ngx-translate/core';

import { LogService } from '../../../../core/services/log.service';
import { Language } from '../../../../shared/models/common/language.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LanguagesService } from '../../services/languages.service';

import { CheckboxModule } from 'primeng/checkbox';

@Component({
    selector: 'languages-form',
    template: LanguagesFormComponentView,
    imports: [
        CheckboxModule,
    ],
})
export class LanguagesFormComponent implements OnInit {

    @ViewChild('activeTemplate', { static: true }) activeTemplate!: TemplateRef<any>;

    private searchValue: string = '';
    private languageForm: FormGroup;
    private language: Language;

    private getLanguage() {
        if (this.$stateParams.id) {

            this.LanguagesService.getLanguage(this.$stateParams.id).subscribe({

                next: (languageData) => {

                    this.language = languageData;
                    this.languageForm.patchValue(languageData);

                },

                error: (err) => {

                    console.error('Something went wrong... ', err);

                }

            })

        } 
    };

    private goToCancel() {

        this.$state.go('common.languages.list');

    }

    /*

    Por orden de Roberto desactivamos el borrado 
     private checkDelete() {

        this.confirmationService.confirm({
            message: this.translate.instant('languages.management.check_delete'),
            header: this.translate.instant('general.remove'),
            accept: () => {
                this.LanguagesService.deleteLanguage(this.language).subscribe({
                    next: () => {
                        setTimeout(() => {
                            this.$state.go('common.languages.list');
                        }, 100); // 100ms es suficiente para que el toast se renderice
                    }
                });
            },
            reject: () => {
                // Optional: action on reject (cancel)
            }
        });
        }

    */ 

    private saveLanguage() {

        this.language = {
            id: this.language.id,
            ...this.languageForm.value
        };

        this.LanguagesService.saveLanguage(this.language).subscribe({

            next: () => {
                this.$state.go('common.languages.list');
            },
            error: (errorResponse) => {

                console.log(errorResponse);

                this.confirmationService.confirm({
                    message: errorResponse.error.ExceptionMessage,
                    header: this.translate.instant('general.error'),
                    acceptVisible: false,
                    rejectLabel: this.translate.instant('general.accept'), 
                    reject: () => { }
                });
            }
        
        });

    }

    constructor(@Inject(LogService) private log: LogService,
        @Inject(LanguagesService) private LanguagesService: LanguagesService,
        @Inject(MessageService) private messageService: MessageService,
        @Inject(FormBuilder) private formBuilder: FormBuilder,
        @Inject(ConfirmationService) private confirmationService: ConfirmationService,
        @Inject(TranslateService) private translate: TranslateService,
        @Inject('$stateParams') private $stateParams: any,
        @Inject('$state') private $state: any) {

        const ng1Injector = (window as any).angular.element(document.body).injector();

        this.$stateParams = ng1Injector.get('$stateParams');
        this.$state = ng1Injector.get('$state');

        this.language = {
            id: null,
            created_at: null,
            name: "",
            code: "",
            native_name: "",
            active: false,
        };

    }

    ngOnInit() {
        this.languageForm = this.formBuilder.group({
            name: ['', Validators.required],
            native_name: ['', Validators.required],
            code: ['', Validators.required],
            active: [false]
        });
        this.getLanguage();

    }

    ngAfterViewInit() {}

}
